<div class="add-vehicle-form" #addVehicleForm>
  <form #addVehicleForm="ngForm">
    <div class="icon-bar" *ngIf="openFrom === 'add-vehicle'">
      <div class="icon customer-icon mt-25"
        [ngClass]="{'active': focus?.customer, 'mt-2point5rem': !isCreateVehicleMode}">
        <i class="fal fa-user" [ngClass]="{'font-400': focus?.customer}"></i>
      </div>

      <div class="icon vehicle-icon mt-25" [ngClass]="{'active': focus?.vehicle}">
        <i class="fal fa-car" [ngClass]="{'font-400': focus?.vehicle}"></i>
      </div>

      <div class="icon vehicle-icon mt-25" [ngClass]="{'active': focus?.quickTireSection}"
        *ngIf="from === 'quick-tire-lookup' && !isCreateVehicleMode">
        <i class="fal fa-file" [ngClass]="{'font-400': focus?.quickTireSection}"></i>
      </div>
    </div>

    <div class="icon-bar" *ngIf="openFrom === 'add-appointment'">
      <div class="icon calendar-icon">
      </div>
      <div class="icon customer-icon">
        <i class="fal fa-user"></i>
      </div>
      <div class="icon vehicle-icon active">
        <i class="fal fa-car font-400"></i>
      </div>
      <div class="icon task-icon">
        <i class="fal fa-tasks"></i>
      </div>
      <div class="icon user-icon">
        <i class="fal fa-user-hard-hat"></i>
      </div>
      <div class="icon user-note">
        <i class="fal fa-sticky-note"></i>
      </div>
    </div>

    <div class="ui-g p-0 pr-2 vehicle-fields">

      <div class="ui-g-12 input-row" *ngIf="!vehicle?._id && isCreateVehicleMode && customer.isMFCustomer">
        <div class="font-14 font-400 warning-info pr-2">
          <img src="assets/warning-icon.svg" class="mr-1" />
          <!-- To send invoices to MyFleetCenter, you will need to connect this vehicle to MyFleetCenter first -->
          To send invoices to MyFleetCenter, we recommend connecting the vehicle to MyFleetCenter first
          <span class="font-primary font-14 font-600 pointer" (click)="handleOpenFleetCustomer()">
            <i class="fal fa-search ml-1 mr-1"></i>
            Search MyFleetCenter
          </span>
        </div>
      </div>

      <!-- Start Customer Search -->
      <div class="ui-g-12 input-row" [ngClass]="{'no-create-m-customer': !isCreateVehicleMode}">
        <div class="input-field search-custom-autoleap">
          <app-auto-complete id="ac-customer" listId="ac-customer-list" placeholder="Search customer *" label="Customer"
            field="fullName" theme="primary" noRecordIcon="fal fa-user font-16 pr-2"
            noRecordText="No customers match your search" [fontSize]="14" [suggestions]="customerSuggestions"
            [floatingLabel]="true" [isLoading]="isLoading" [hasCustomEditableField]="focus?.customer || query?.customer"
            [autoFocus]="true" [disabled]="customerSearchDisabled" [isInvalid]="errors?.customer"
            [errorMessage]="errors?.customer" [value]="customer.fullName" (appSelect)="onCustomerSelect($event)"
            (appCompletedMethod)="onSearchCustomer($event)" (appClickInput)="handleFocus('customer')"
            (appClickOutside)="handleBlur('customer')" (appChange)="handleChange('customer', $event)"
            [imgIcon]="helperService.showMFCIconOnInput(customer)" (appClear)="onSuggestionsClear('customer')"
            scrollHeight="198px" [isInvalid]="errors?.transferVehicleError">
            <ng-template let-item appTemplate="item">
              <div class="width-100p">
                <div class="flex-column flex-center-start font-13">
                  <div class="flex-between-center width-100p">
                    <span class="font-600">
                      <img [src]="helperService.showMFCIconOnInput(item)" class="mr-1 mfc-input-icon"
                        *ngIf="helperService.showMFCIconOnInput(item)" />
                      {{item?.fullNameQBO}}
                    </span>
                    <span class="font-600">{{item?.phone | mask: '(000) 000-0000'}}</span>
                  </div>
                  <div class="flex-start-center mt-1">{{item?.email}}</div>
                </div>
              </div>
            </ng-template>
            <ng-template let-item appTemplate="editable">
              <span id="create-customer" (click)="openCreateCustomer()">Create new customer</span>
            </ng-template>
          </app-auto-complete>
          <span *ngIf="errors?.transferVehicleError" class="font-error vin-wraaper ml-0">
            <span class="vin-exist">{{errors?.transferVehicleError}}&nbsp;<span
                class="font-bold">{{customerList[0]?.customerName}}</span></span>
          </span>
        </div>
      </div>
      <!-- End Customer Search -->

      <!-- Start Vehicle Search -->
      <div *ngIf="isMotorLookupEnabled || isCarfaxEnabled" class="ui-g-12 input-row"
        [ngClass]="{'no-create-m-vehicle': !isCreateVehicleMode}">
        <!-- Customer Vehicle Search -->
        <ng-container *ngIf="from === 'quick-tire-lookup' && !isCreateVehicleMode else onlineVehicleSearch">
          <app-auto-complete id="ac-vehicle" listId="ac-vehicle-list" label="Vehicle" field="name" theme="primary"
            noRecordIcon="fal fa-user font-16 pr-2" noRecordText="No vehicles match your search"
            staticListHeaderTitle="Select from vehicles already created for this customer"
            [headerButtonTitle]="isMFCustomerHeaderButton().title" (appClickHeader)="handleOpenFleetCustomer()"
            [headerButtonClass]="isMFCustomerHeaderButton().class" [headerButtonIcon]="isMFCustomerHeaderButton().icon"
            [hasHeaderButton]="isMFCustomerHeaderButton().btn"
            [hasStaticListHeader]="customerVehicleSuggestions?.length" [placeholder]="vehicleSearchPlaceholder"
            [isShowNoRecordForceFully]="isShowNoRecordForceFully" [fontSize]="14" [hasCustomListTemplate]="true"
            [suggestions]="customerVehicleSuggestions" [floatingLabel]="false" [isLoading]="isLoading"
            [hasCustomEditableField]="focus?.vehicle || query?.vehicle" [autoFocus]="focus?.vehicle"
            [disabled]="!customer?._id || vehicleSearchDisabled" [isInvalid]="errors?.vehicle"
            [errorMessage]="errors?.vehicle" [value]="customerVehicle?.name || query?.vehicle"
            (appCompletedMethod)="onSearchCustomerVehicle($event)" (appClickInput)="handleFocus('vehicle')"
            (appClickOutside)="handleBlur('vehicle')" (appClear)="onSuggestionsClear('customerVehicle')"
            scrollHeight="198px" [isInvalid]="errors?.transferVehicleError">
            <ng-template let-query="query" let-selectedIndex="selectedIndex" let-close="close" appTemplate="list">
              <li *ngIf="customerVehicleType?.active?.length > 0"
                class="font-12 font-600 p-2 bt-1 source-suggestions-label active-vehicle-header">
                <p class="mb-0">Active vehicles</p>
              </li>

              <li class="source-suggestions-local">
                <ul class="source-suggestions-local-list" id="e-serviceItem-local-source">
                  <li class="font-12 font-black p-2 source-suggestion-label"
                    *ngFor="let item of customerVehicleType?.active; let i = index" id="item-{{i}}"
                    (click)="onCustomerVehicleSelect(item, close)">
                    <div class="width-100p font-14 flex-column">
                      <div class="flex-between-center">
                        <p class="m-0" [innerHTML]="item?.name"></p>
                        <p class="m-0 search-license-plate" [hidden]="!item?.licensePlate"
                          [innerHTML]="item?.licensePlate">
                        </p>
                      </div>

                      <div class="flex-between-center">
                        <p class="m-0 font-gray-35 font-12" [innerHTML]="item?.engine"></p>
                        <p class="m-0 font-gray-35 font-12" *ngIf="item?.VIN" [innerHTML]="item?.VIN"></p>
                      </div>
                    </div>
                  </li>
                </ul>
              </li>

              <li *ngIf="customerVehicleType.inactive?.length > 0"
                class="font-12 font-600 p-2 bt-1 source-suggestions-label in-active-header">
                <p class="mb-0">Inactive vehicles</p>
              </li>

              <li class="source-suggestions-local in-active-list">
                <ul class="source-suggestions-local-list" id="e-serviceItem-local-source">
                  <li class="font-12 font-black p-2 source-suggestion-label archived"
                    *ngFor="let item of customerVehicleType?.inactive; let j = index" id="item-{{ j }}">
                    <div class="width-100p font-14 flex-column">
                      <div class="flex-between-center">
                        <p class="m-0" [innerHTML]="item?.name"></p>
                        <p class="m-0 search-license-plate" [hidden]="!item?.licensePlate"
                          [innerHTML]="item?.licensePlate">
                        </p>
                      </div>

                      <div class="flex-between-center">
                        <p class="m-0 font-gray-35 font-12" [innerHTML]="item?.engine"></p>
                        <p class="m-0 font-gray-35 font-12" *ngIf="item?.VIN" [innerHTML]="item?.VIN"></p>
                      </div>
                    </div>
                  </li>
                </ul>
              </li>
            </ng-template>

            <ng-template let-item appTemplate="editable">
              <span id="create-customer" (click)="openCreateVehicle(true)">Create new vehicle</span>
            </ng-template>
          </app-auto-complete>
        </ng-container>

        <ng-template #onlineVehicleSearch>
          <div class="p-0 input-field pr-5" [ngClass]="{'ui-g-7': isCarfaxEnabled && !isCreateVehicleMode,
          'ui-g-8': isCarfaxEnabled && isCreateVehicleMode,
          'ui-g-12': !isCarfaxEnabled }">
            <app-auto-complete id="ac-vehicle" listId="ac-vehicle-list" label="Vehicle" itemWidth="100%" theme="primary"
              noRecordIcon="fal fa-car  font-16 pr-2" noRecordText="No vehicle match your search"
              [placeholder]="vehicleSearchPlaceholder" [textTruncate]="true" [fontSize]="14"
              [headerButtonTitle]="isMFCustomerHeaderButton().title" (appClickHeader)="handleOpenFleetCustomer()"
              [headerButtonClass]="isMFCustomerHeaderButton().class"
              [headerButtonIcon]="isMFCustomerHeaderButton().icon" [hasHeaderButton]="isMFCustomerHeaderButton().btn"
              [suggestions]="vehicleSuggestions" [floatingLabel]="false" [hasCustomListTemplate]="true"
              [hasCustomEditableField]="focus?.vehicle || query?.vehicle" [autoFocus]="focus?.vehicle"
              [disabled]="vehicleSearchDisabled" [isInvalid]="errors?.vehicle" [errorMessage]="errors?.vehicle"
              [isLoading]="isLoading" [value]="vehicle?.title" [isLoadingData]="searchingVehicles"
              (appCompletedMethod)="onSearchVehicle($event)" (appClickInput)="handleFocus('vehicle')"
              (appClickOutside)="handleBlur('vehicle')" (appChange)="handleChange('vehicle', $event)"
              (appClear)="onSuggestionsClear('vehicle')" scrollHeight="186px">
              <ng-template let-query="query" let-selectedIndex="selectedIndex" let-close="close" appTemplate="list">
                <li class="font-12 font-600 p-2 bt-1 source-suggestions-label active-vehicle-header"
                  *ngIf="vehicleType?.active?.length > 0">
                  <p class="mb-0">Active vehicles</p>
                </li>
                <li class="source-suggestions-local">
                  <ul class="source-suggestions-local-list" id="e-serviceItem-local-source">
                    <li class="font-12 font-black p-2 source-suggestion-label"
                      *ngFor="let item of vehicleType?.active; let i = index" id="item-{{ i }}"
                      (click)="onVehicleSelect(item, close)">
                      <div class="width-100p font-14 flex-column" [hidden]="item?.isHeader">
                        <div class="flex-between-center">
                          <p class="m-0" [innerHTML]="item?.htmlName"></p>
                          <p class="m-0 search-license-plate" [hidden]="!item?.htmlLicensePlate"
                            [innerHTML]="item?.htmlLicensePlate">
                          </p>
                        </div>

                        <div class="flex-between-center">
                          <p class="m-0 font-gray-35 font-12" [innerHTML]="item?.htmlEngine"></p>
                          <p class="m-0 font-gray-35 font-12" *ngIf="item?.htmlVin" [innerHTML]="item?.htmlVin"></p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li class="font-12 font-600 p-2 bt-1 source-suggestions-label in-active-header"
                  *ngIf="vehicleType.inactive?.length > 0">
                  <p class="mb-0">Inactive vehicles</p>
                </li>
                <li class="source-suggestions-local in-active-list">
                  <ul class="source-suggestions-local-list" id="e-serviceItem-local-source">
                    <li class="font-12 font-black p-2 source-suggestion-label archived"
                      *ngFor="let item of vehicleType?.inactive; let j = index" id="item-{{ j }}">
                      <div class="width-100p font-14 flex-column" [hidden]="item?.isHeader">
                        <div class="flex-between-center">
                          <p class="m-0" [innerHTML]="item?.htmlName"></p>
                          <p class="m-0 search-license-plate" [hidden]="!item?.htmlLicensePlate"
                            [innerHTML]="item?.htmlLicensePlate">
                          </p>
                        </div>

                        <div class="flex-between-center">
                          <p class="m-0 font-gray-35 font-12" [innerHTML]="item?.htmlEngine"></p>
                          <p class="m-0 font-gray-35 font-12" *ngIf="item?.htmlVin" [innerHTML]="item?.htmlVin"></p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
              </ng-template>

              <ng-template appTemplate="editable">
                <div id="create-vehicle" class="width-100p" (click)="openCreateVehicle()">
                  Create manually
                </div>
              </ng-template>
            </app-auto-complete>
          </div>

          <div class="p-0 pb-7px input-field carfax-reg-state-field"
            [ngClass]="{'ui-g-4': isCreateVehicleMode,'ui-g-5': !isCreateVehicleMode }" *ngIf="isCarfaxEnabled">
            <app-dropdown theme="primary" hPosition="left" scrollHeight="215px" styleClassSelectedView="p-0 mt-5px"
              inactiveItemsKey="stateCode" [disabled]="disabled?.state" [selectInactiveItems]="false"
              [focusOnSelectedValue]="false" [options]="states" [isDropdownIconVisible]="false"
              [hasCustomOpenTemplate]="true" [hasCustomItemTemplate]="true" [hasListHeader]="false"
              (appSelect)="onStateSelect($event, true)">
              <ng-template let-item appTemplate="open-dropdown-btn">

                <div class="flex-center-center font-14 text-truncate">
                  Registration&nbsp;state: <span class="font-600 font-primary pl-2 text-truncate">
                    {{vehicle?.state || defaultRegState}}
                  </span>
                </div>
              </ng-template>

              <ng-template let-item appTemplate="item">
                <div [hidden]="item?.isHeader" class="p-2 font-secondary-700">{{item?.stateCode}} - {{item?.state}}
                </div>
                <div [hidden]="!item?.isHeader" class="p-2 font-gray-55 font-600 item-country-header">{{item?.country}}
                </div>
              </ng-template>
            </app-dropdown>
          </div>
        </ng-template>
      </div>
      <!-- End Vehicle Search -->

      <div *ngIf="from !== 'quick-tire-lookup' || isCreateVehicleMode" class="vehicle-fields"
        [@toggleBoxNew]="isCreateVehicleMode ? 'openNew' : 'closedNew'">
        <div [hidden]="!isCreateVehicleMode">

          <div class="ui-g-12 input-row">
            <!-- Year -->
            <div class="ui-g-4 input-field pr-5">
              <div>
                <app-input id="v-year" type="text" theme="primary" placeholder="Year *" [disabled]="disabled?.year"
                  [fontSize]="14" [floatingLabel]="true" [value]="vehicle?.year" [mask]="'0000'"
                  [isInvalid]="errors?.year" [errorMessage]="errors?.year"
                  [autoFocus]="isCreateVehicleMode && customer?.fullName" (appChange)="handleChange('year', $event)">
                </app-input>
              </div>
            </div>

            <!-- Make -->
            <div class="ui-g-4 input-field pr-5">
              <div>
                <app-input id="v-make" type="text" theme="primary" placeholder="Make" [disabled]="disabled?.make"
                  [maxLength]="35" [fontSize]="14" [floatingLabel]="true" [value]="vehicle?.make"
                  [isInvalid]="errors?.make" [errorMessage]="errors?.make" (appChange)="handleChange('make', $event)">
                </app-input>
              </div>
            </div>

            <!-- Model -->
            <div class="ui-g-4 input-field">
              <app-input id="v-model" type="text" theme="primary" placeholder="Model" [disabled]="disabled?.model"
                [maxLength]="35" [fontSize]="14" [floatingLabel]="true" [value]="vehicle?.model"
                [isInvalid]="errors?.model" [errorMessage]="errors?.model" (appChange)="handleChange('model', $event)">
              </app-input>
            </div>
          </div>

          <div class="ui-g-12 input-row">
            <!-- VIN -->
            <div class="ui-g-4 input-field pr-5">
              <div [ngClass]="{'hide-vin-input': vehicle?.vin && !vinInputVisible}">
                <app-input id="v-vin" type="text" theme="primary" placeholder="VIN" [disabled]="disabled?.vin"
                  [maxLength]="17" [fontSize]="14" [floatingLabel]="true" [value]="vehicle?.vin"
                  [isInvalid]="errors?.vin" [errorMessage]="errors?.vin" (appChange)="handleChange('vin', $event)"
                  [autoFocus]="vinInputVisible" (appFocus)="handleFocus('vin')" (appBlur)="handleBlur('vin')"
                  (appClickOutside)="handleBlur('vin')">
                </app-input>

                <span *ngIf="errors?.vin && vehicleAlreadyAdded" class="font-error vin-wraaper">
                  <span class="vin-exist">{{vinExsistErrMsg}}</span>
                  <i class="fal fa-arrow-circle-right pl-1"></i>
                </span>
              </div>

              <!-- Highlighted Vehicle VIN -->
              <div class="block-vin-wrapper position-relative" [hidden]="vinInputVisible || !vehicle?.vin"
                (click)="onFocusVin()">
                <div class="block-vin-heading">VIN</div>
                <div class="vin-number flex-start-center" [innerHTML]="vehicle?.vin | highlightVin"></div>
              </div>
            </div>

            <!-- License plate -->
            <div class="ui-g-4 input-field pr-5">
              <app-input id="v-license" type="text" theme="primary" [placeholder]="fieldPlaceholder.licensePlate"
                [maxLength]="10" [disabled]="disabled?.licensePlateNo" [fontSize]="14" [floatingLabel]="true"
                [value]="vehicle?.licensePlateNo" [autoFocus]="licenseInputVisible" [isInvalid]="errors?.licensePlateNo"
                [errorMessage]="errors?.licensePlateNo" (appFocus)="handleFocus('licensePlateNo')"
                (appBlur)="handleBlur('licensePlateNo')" (appClickOutside)="handleBlur('licensePlateNo')"
                (appChange)="handleChange('licensePlateNo', $event)">
              </app-input>
              <span *ngIf="errors?.licensePlateNo && vehicleAlreadyAdded" class="font-error licence-wraaper">
                <span class=""> {{lincencePlateErrMsg}} </span>
                <i class="fal fa-arrow-circle-right pl-1"></i>
              </span>
            </div>

            <div class="ui-g-4 input-field">
              <app-auto-complete id="v-registration-state" listId="v-registration-state-list" theme="inline"
                scrollHeight="160px" [isLoading]="isStateSearching" [placeholder]="fieldPlaceholder.regState"
                [label]="fieldPlaceholder.regState" [textTruncate]="true" [disabled]="disabled?.state"
                [value]="vehicle.registrationState" [suggestions]="stateResults" [floatingLabel]="true" [fontSize]="14"
                [isInvalid]="errors?.registrationState" [errorMessage]="errors?.registrationState"
                (appFocus)="handleFocus('registrationState')" [closeOnSelection]="true"
                (appSelect)="onStateSelect($event)" (appCompletedMethod)="onStateSearch($event)" (appClear)="onClear()">
                <ng-template let-item appTemplate="item">
                  <div class="flex-between-center">
                    <div class="font-14">
                      {{item.stateCode}} - {{item?.state}}
                    </div>
                  </div>
                </ng-template>
              </app-auto-complete>
            </div>
          </div>

          <div class="ui-g-12 input-row">
            <div class="ui-g-4 input-field pr-5">
              <div>
                <app-input id="v-engine" type="text" theme="primary" placeholder="Engine" [disabled]="disabled?.engine"
                  [maxLength]="35" [fontSize]="14" [floatingLabel]="true" [value]="vehicle?.engine"
                  [isInvalid]="errors?.engine" [errorMessage]="errors?.engine"
                  (appChange)="handleChange('engine', $event)">
                </app-input>
              </div>
            </div>

            <div class="ui-g-4 input-field pr-5">
              <app-dropdown id="d-transmission" listId="d-transmission-list" placeholder="Transmission" theme="primary"
                field="label" [fontSize]="14" [value]="vehicle.transmission" [listItemFontSize]="13"
                [floatingLabel]="true" [options]="transmissions" [isDropdownIconVisible]="true"
                (appSelect)="onTransmissionSelect($event)">
              </app-dropdown>
            </div>

            <div class="ui-g-4 input-field">
              <div class="ui-g-6 input-field pr-3">
                <div>
                  <app-input id="v-mileage" type="text" theme="primary" placeholder="Mileage" mask="0000000000"
                    [fontSize]="14" [floatingLabel]="true" [value]="vehicle?.mileage" [isInvalid]="errors?.mileage"
                    [errorMessage]="errors?.mileage" (appChange)="handleChange('mileage', $event)">
                  </app-input>
                </div>
              </div>
              <div class="ui-g-6 input-field pl-3">
                <div>
                  <app-dropdown placeholder="Units" theme="primary" field="label" [fontSize]="14"
                    [listItemFontSize]="13" [value]="vehicle.mileageMeasuringUnit" [floatingLabel]="true"
                    [options]="mileageUnits" [isDropdownIconVisible]="true" (appSelect)="onMileageUnitSelect($event)">
                  </app-dropdown>
                </div>
              </div>
            </div>
          </div>

          <div class="ui-g-12 input-row">
            <div class="ui-g-4 input-field"></div>
            <div class="ui-g-4 input-field vehicle-color pr-5">
              <app-auto-complete id="ac-color" listId="ac-color-list" placeholder="Search color" label="Color"
                theme="primary" field="name" [value]="vehicle?.color?.name" editFieldLabel="Create new color"
                editableItemIdKey="_id" editFieldPlaceholder="Enter new color" scrollHeight="146px" [fontSize]="14"
                [suggestions]="vehicleColorsSuggestions" [floatingLabel]="true" [hasEditableField]="focus?.color"
                [hasColorSelection]="false" [hasFutureSelectionField]="false" (appSelect)="onVehicleColorSelect($event)"
                (appCompletedMethod)="onSearchVehicleColor($event)" (appClickInput)="handleFocus('color')"
                (appClickOutside)="handleBlur('color')" (appChange)="handleChange('color', $event)"
                (appClear)="onSuggestionsClear('color')" (appSave)="onVehicleColorCreate($event)"
                (appUpdateItem)="onColorUpdate($event,'vehicle_color')">
                <ng-template let-item let-editItem="editItem" appTemplate="item">
                  <div class="tag-item flex-between-center">
                    <div>
                      <span>{{ item?.name }}</span>
                    </div>
                    <div class="tag-item-action flex-end-center">
                      <i class="fas fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); editItem(item)"></i>
                    </div>
                  </div>
                </ng-template>
              </app-auto-complete>
            </div>
            <div class="ui-g-4 input-field drive-type pr-5">
              <app-auto-complete id="ac-drivetype" listId="ac-drivetype-list" placeholder="Search drive type"
                label="Drive type" theme="primary" field="name" editFieldLabel="Create drive type"
                editableItemIdKey="_id" editFieldPlaceholder="Enter drive type" scrollHeight="146px" [fontSize]="14"
                [suggestions]="driverTypeSuggestions" [value]="vehicle?.driveType?.name" [floatingLabel]="true"
                [hasEditableField]="focus?.driverType" [hasFutureSelectionField]="false"
                (appSelect)="onDriverTypeSelect($event)" (appCompletedMethod)="onSearchDriverType($event)"
                (appClickInput)="handleFocus('driverType')" (appClickOutside)="handleBlur('driverType')"
                (appChange)="onSearchDriverType($event)" (appClear)="onSuggestionsClear('driverType')"
                (appSave)="onCreateDriverType($event)" (appUpdateItem)="onDriveTypeUpdate($event, 'drive_type')">
                <ng-template let-item let-editItem="editItem" appTemplate="item">
                  <div class="tag-item flex-between-center">
                    <div>
                      <span>{{ item?.name }}</span>
                    </div>
                    <div class="tag-item-action flex-end-center">
                      <i class="fas fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); editItem(item)"></i>
                    </div>
                  </div>
                </ng-template>
              </app-auto-complete>
            </div>
          </div>

          <!-- Fleet vehicle name -->
          <div class="ui-g-12 input-row">
            <div class="ui-g-12 ui-lg-4 pr-5 input-field position-relative vehicle-name-expose">
              <app-input id="v-fleet-vehicle-name" type="text" theme="primary"
                placeholder="Vehicle name (exposed to customers)*" [disabled]="disabled?.vehicleName" [fontSize]="14"
                [maxLength]="75" [floatingLabel]="true" [value]="vehicle?.vehicleName" [isInvalid]="errors?.vehicleName"
                [errorMessage]="errors?.vehicleName" (appFocus)="handleFocus('vehicleName')"
                (appBlur)="handleBlur('vehicleName')" (appChange)="handleChange('vehicleName', $event)">
              </app-input>

              <i class="fal fa-info-circle text-dark vehicle-name-tooltip" pTooltip="Custom vehicle name is searchable."
                tooltipPosition="top"></i>
            </div>
          </div>

          <div class="ui-g-12 input-row">
            <div class="input-field">
              <div>
                <app-textarea type="text" theme="primary" textAreaId="vehicle-add-textarea" placeholder="Notes"
                  [maxLength]="100" [rows]="1" [fontSize]="14" [floatingLabel]="true" [autoGrow]="true"
                  [maxAutoGrowHeight]="68" [value]="vehicle?.notes" [isInvalid]="errors?.notes"
                  [errorMessage]="errors?.notes" (appChange)="handleChange('notes', $event)">
                </app-textarea>
              </div>
            </div>
          </div>

          <div class="ui-g-12 input-row">
            <app-tags-list buttonId="vehicle-add-tags" addTagTitle="Add tags" type="vehicle" [tags]="vehicleTags"
              [selectedTags]="vehicle?.tags" [fontSize]="11" [hasCreateOption]="true" [isDeleteable]="true"
              (appSelect)="onTagSelect($event)" (appDelete)="onTagDelete($event)" (appCreateTag)="onTagCreate($event)"
              (appShowSuggestion)="onTagFocus()" (appTagDeleted)="handleTagDelete($event)">
            </app-tags-list>
          </div>
        </div>
        <!-- collapse end-->
      </div>

      <!-- quick tire lookup section -->
      <div class="ui-g-12 input-row" [ngClass]="{'no-create-m-vehicle': !isCreateVehicleMode}"
        *ngIf="from === 'quick-tire-lookup' && customer?._id && customerVehicle?._id">
        <span class="font-14 font-400">How would you like to proceed?</span>
        <div class="p-0 input-field ui-g-12 flex-row pr-2 flex-row flex-wrap">
          <app-radio-button id="new-ro" name="ro-customer" label="Create new RO" class="pr-2"
            styleClassLabel="font-primary" [selectedValue]="estimateId" [value]="'new-ro'"
            (appChange)="handleRadioChange('new-ro', $event)">
          </app-radio-button>

          <div *ngFor="let order of orders" class="flex-start-center mr-3">
            <app-radio-button id="order-{{order?.orderId}}" name="ro-customer" label="RO# {{order?.code}}" class="pr-2"
              styleClassLabel="font-primary" [selectedValue]="estimateId" [value]="order?.orderId"
              [disabled]="orders.disabled" [ngClass]="{'disable-opacity': orders.disabled}"
              (appChange)="handleRadioChange(order?.orderId, $event)">
            </app-radio-button>

            <span class="quick-tire-section font-secondary" [ngClass]="{'disable-opacity': orders.disabled}">
              <i class="far fa-calendar-alt"></i>
              <span class="font-12 ml-2 font-400">{{order?.createdAt | date: 'MMM d, yyyy'}}</span>
            </span>

            <i *ngIf="orders.disabled" class="far fa-info-circle pl-2 font-info-icon font-16 pointer"
              pTooltip="This RO has open {{onlineOrderSource}} parts order." tooltipPosition="top"
              tooltipStyleClass="text-center quick-tire-lookup-tooltip"></i>
          </div>
        </div>
      </div>
      <!-- quick tire lookup End -->
    </div>
  </form>
</div>
